import { render, staticRenderFns } from "./ChangeManagementNotif.vue?vue&type=template&id=8e9cb8b0&lang=pug"
import script from "./ChangeManagementNotif.vue?vue&type=script&lang=js"
export * from "./ChangeManagementNotif.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports